import { GitlabAuth } from '@backstage/core-app-api';
import {
  ApiBlueprint,
  configApiRef,
  createFrontendModule,
  discoveryApiRef,
  gitlabAuthApiRef,
  oauthRequestApiRef,
} from '@backstage/frontend-plugin-api';
import type { OAuthApi } from '@backstage/frontend-plugin-api';
import { expandGitlabScopes } from './expandGitlabScopes';

function withExpandedGitlabScopes<T extends OAuthApi>(api: T): T {
  return Object.assign(Object.create(api), {
    getAccessToken: (scope?: string | string[], options?: Parameters<T['getAccessToken']>[1]) =>
      api.getAccessToken(expandGitlabScopes(scope), options),
  });
}

const gitlabAuthApi = ApiBlueprint.make({
  name: 'gitlab-auth-scoped',
  params: defineParams =>
    defineParams({
      api: gitlabAuthApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        oauthRequestApi: oauthRequestApiRef,
        configApi: configApiRef,
      },
      factory: ({ discoveryApi, oauthRequestApi, configApi }) => {
        const api = GitlabAuth.create({
          configApi,
          discoveryApi,
          oauthRequestApi,
          environment: configApi.getOptionalString('auth.environment'),
          defaultScopes: ['read_user', 'api'],
        });
        return withExpandedGitlabScopes(api);
      },
    }),
});

export const gitlabAuthModule = createFrontendModule({
  pluginId: 'app',
  extensions: [gitlabAuthApi],
});
